/* eslint-disable react/jsx-props-no-spreading */
import { Boundary, MessageDisplay } from 'components/common';
import { useDocumentTitle, useScrollTop } from 'hooks';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import firebase from 'firebase/firebase';
import { query, collection, orderBy } from 'firebase/firestore';
import { useCollection } from 'react-firebase-hooks/firestore';
import { useTranslation } from 'react-i18next';
import { CheckOutlined, LoadingOutlined } from '@ant-design/icons';
import { displayActionMessage } from 'helpers/utils';
import BrandItem from '../components/BrandItem';

const Brands = () => {
  const { t } = useTranslation();
  useDocumentTitle('Admin - Uilpi');
  useScrollTop();
  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  });

  const [isUploading, setUploading] = useState(false);
  const [newBrand, setNewBrand] = useState('');

  const onSubmitBrand = async () => {
    setUploading(true);
    if (newBrand) {
      await firebase
        .addBrand(newBrand)
        .catch(() => displayActionMessage('errorMessage1', 'error'));
      document.getElementById('brandInput').value = '';
    }
    setUploading(false);
  };

  const handleChangeBrand = (e) => {
    setNewBrand(e.target.value);
  };

  const [brands, isLoadingBrands, errorBrands] = useCollection(
    query(collection(firebase.db, 'brands'), orderBy('name')),
    {
      snapshotListenOptions: { includeMetadataChanges: true }
    }
  );

  return (
    <Boundary>
      <div className="product-admin-header">
        <h3 className="product-admin-header-title">
          {t('adminBrandsMessage')}
        </h3>
      </div>
      <div className="product-admin-subheader">
        <span>{t('adminBrandsParagraph')}</span>
      </div>
      <div className="product-admin-items">
        <div>
          <div className="grid grid-product grid-count-6">
            <div className="grid-col grid-col-onlydesktop">
              <h5>{t('productTableName')}</h5>
            </div>
          </div>
          {errorBrands && <MessageDisplay message={errorBrands} />}
          {brands &&
            !isLoadingBrands &&
            brands.docs.map((brand) => {
              return (
                <BrandItem
                  key={brand.id}
                  id={brand.id}
                  name={brand.data().name}
                />
              );
            })}
        </div>
        <div className="product-form">
          <div className="product-form-file">
            <div className="product-form-field">
              <input id="brandInput" type="text" onChange={handleChangeBrand} />
            </div>
          </div>
        </div>
        <button
          type="button"
          className="button button-small"
          disabled={isUploading}
          onClick={onSubmitBrand}
        >
          {isUploading ? <LoadingOutlined /> : <CheckOutlined />}
          &nbsp;
          {isUploading ? t('loadingMessage') : t('buttonConfirm')}
        </button>
      </div>
    </Boundary>
  );
};

export default withRouter(Brands);
